export default "assets/images/icons/calendar-bold-abdae9af.svg";